import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";

import authReducer from "./auth/authSlice";
import activeReducer from "./active/activeSlice";
import userReducer from "./users/usersSlice";
import whatsappLoginReducer from "./whatsappLogin/whatsappLoginSlice";
import countryReducer from "./country/countrySlice";
import selectCountryReducer from "./selectCountry/selectCountrySlice";
import regionReducer from "./region/regionSlice";
import selectRegionReducer from "./selectRegion/selectRegionSlice";
import categoryReducer from "./category/categorySlice";
import selectCategoryReducer from './selectCategory/selectCategorySlice';
import addOnCategoryReducer from "./addonCategory/addonCategorySlice";
import selectAddOnCategoryReducer from "./selectAddOnCategory/selectAddOnCategorySlice";
import bundleCategoryReducer from "./bundleCategory/bundleCategorySlice";
import selectBundleCategoryReducer from "./selectBundleCategory";
import bundleSubcategoryReducer from "./bundleSubcategory/bundleSubcategorySlice";
import selectBundleSubcategoryReducer from "./selectBundleSubcategory/selectBundleSubcategorySlice";
import bundleProductReducer from "./bundleProduct/bundleProductSlice";
import bundleCakeReducer from "./bundleCake/bundleCakeSlice";
import selectBundleCakeReducer from "./selectBundleCake/selectBundleCakeSlice";
import addOnProductReducer from "./addonProduct/addonProductSlice";
import selectAddOnProductReducer from "./selectAddOnProduct/selectAddOnProductSlice";
import addOnProductVariantReducer from "./addonProductVariant/addonProductVariantSlice";
import colorReducer from "./color/colorSlice";
import cakeBoxReducer from "./cakeBox/cakeBoxSlice";
import shapeReducer from "./shape/shapeSlice";
import selectShapeReducer from './selectShape/selectShapeSlice';
import flavorReducer from "./flavor/flavorSlice";
import selectFlavorReducer from "./selectFlavor/selectFlavorSlice";
import toppingsCategoryReducer from './toppingsCategory/toppingsCategorySlice';
import selectToppingsCategoryReducer from './selectToppingCategory/selectToppingCategorySlice';
import toppingsCategoryItemReducer from './toppingsCategoryItem/toppingsCategoryItemSlice';
import selectToppingsCategoryItemReducer from './selectToppingCategoryItem/selectToppingCategoryItemSlice';
import categoryCakeReducer from "./categoryCake/categoryCakeSlice";
import promoCodeReducer from "./promoCode/promoCodeSlice";
import orderReducer from './order/orderSlice';
import walletTransactionReducer from './walletTransaction/walletTransactionSlice';
import userWishlistReducer from './userWishlist/userWishlistSlice';
import rewardHistoryReducer from './rewardHistory/rewardHistorySlice';
import referralSummaryReducer from './referralSummary/referralSummarySlice';
import orderStatusChangeReducer from './orderStatusChange/orderStatusChangeSlice';
import orderUserWiseReducer from './orderUserWise/orderUserWiseSlice';
import dashboardReportReducer from './dashboardReport/dashboardReportSlice';
import pushNotificationManagementReducer from './pushNotificationManagement/pushNotificationManagementSlice';
import settingsReducer from './settings/settingsSlice';
import sliderReducer from './slider/sliderSlice';
import selectCategoryCakeReducer from "./selectCategoryCake/selectCategoryCakeSlice";
import contactFormReducer from './contactForm/contactFormSlice';
import orderExportReducer from './orderExport/orderExportSlice';
import dashboardOrderReducer from './dashboardOrders/dashboardOrderSlice';
import notificationReducer from './notification/notificationSlice';
import sellingCakeReportReducer from './sellingCakeReport/sellingCakeReportSlice';
import adminAnalyticsReducer from './adminAnalytics/adminAnalyticsSlice';
import selectFlavorExportReducer from './selectFlavorExport/selectFlavorExportSlice';
import selectToppingCategoryItemExportReducer from './selectToppingCategoryItemExport/selectToppingCategoryItemExportSlice';
import downloadOrderDetailsReducer from './downloadOrderDetails/slice';
import pendingOrdersCountReducer from './pendingOrdersCount/pendingOrdersCountSlice';
import orderItemReducer from './orderItem/orderItemSlice';
import cakeEditReducer from './cakeEdit/cakeEditSlice';
import cakeEditLogsReducer from './cakeEditLogs/cakeEditLogsSlice';
import partnerReducer from './partner/partnerSlice';
import partnerApiKeyReducer from './partnerApiKey/partnerApiKeySlice';
import partnerAuditLogReducer from './partnerAuditLog/partnerAuditLogSlice';
import serviceVendorReducer from './serviceVendor/serviceVendorSlice';
import serviceCategoryReducer from './serviceCategory/serviceCategorySlice';
import serviceProductReducer from './serviceProduct/serviceProductSlice';

const reducers = {
  auth: authReducer,
  active: activeReducer,
  whatsappLogin: whatsappLoginReducer,
  user: userReducer,
  country: countryReducer,
  selectCountry: selectCountryReducer,
  region: regionReducer,
  selectRegion: selectRegionReducer,
  category: categoryReducer,
  addOnCategory: addOnCategoryReducer,
  selectAddOnCategory: selectAddOnCategoryReducer,
  bundleCategory: bundleCategoryReducer,
  selectBundleCategory: selectBundleCategoryReducer,
  bundleSubcategory: bundleSubcategoryReducer,
  selectBundleSubcategory: selectBundleSubcategoryReducer,
  bundleProduct: bundleProductReducer,
  bundleCake: bundleCakeReducer,
  selectBundleCake: selectBundleCakeReducer,
  addOnProduct: addOnProductReducer,
  selectAddOnProduct: selectAddOnProductReducer,
  addOnProductVariant: addOnProductVariantReducer,
  color: colorReducer,
  cakeBox: cakeBoxReducer,
  shape: shapeReducer,
  selectShape: selectShapeReducer,
  flavor: flavorReducer,
  toppingsCategory: toppingsCategoryReducer,
  selectToppingsCategory: selectToppingsCategoryReducer,
  toppingsCategoryItem: toppingsCategoryItemReducer,
  selectToppingsCategoryItem: selectToppingsCategoryItemReducer,
  categoryCake: categoryCakeReducer,
  selectFlavor: selectFlavorReducer,
  selectCategory: selectCategoryReducer,
  promoCode: promoCodeReducer,
  order: orderReducer,
  walletTransaction: walletTransactionReducer,
  userWishlist: userWishlistReducer,
  rewardHistory: rewardHistoryReducer,
  referralSummary: referralSummaryReducer,
  orderStatusChange: orderStatusChangeReducer,
  orderUserWise: orderUserWiseReducer,
  dashboardReport: dashboardReportReducer,
  pushNotificationManagement: pushNotificationManagementReducer,
  settings: settingsReducer,
  slider: sliderReducer,
  selectCategoryCake: selectCategoryCakeReducer,
  contactForm: contactFormReducer,
  orderExport: orderExportReducer,
  dashboardOrder: dashboardOrderReducer,
  notification: notificationReducer,
  sellingCakeReport: sellingCakeReportReducer,
  adminAnalytics: adminAnalyticsReducer,
  selectFlavorExport: selectFlavorExportReducer,
  selectToppingCategoryItemExport: selectToppingCategoryItemExportReducer,
  downloadOrderDetails: downloadOrderDetailsReducer,
  pendingOrdersCount: pendingOrdersCountReducer,
  orderItem: orderItemReducer,
  cakeEdit: cakeEditReducer,
  cakeEditLogs: cakeEditLogsReducer,
  partner: partnerReducer,
  partnerApiKey: partnerApiKeyReducer,
  partnerAuditLog: partnerAuditLogReducer,
  serviceVendor: serviceVendorReducer,
  serviceCategory: serviceCategoryReducer,
  serviceProduct: serviceProductReducer,
};

export const rootReducer = combineReducers(reducers);

const resettableRootReducer = (
  state: ReturnType<typeof rootReducer> | undefined | any,
  action: AnyAction
) => {
  if (action.type === "auth/logoutUser/fulfilled") {
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: resettableRootReducer,
  // devTools: false
});

export default store;

// Define type for hooks
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export hooks
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
